import { assert } from '@ember/debug';
import Enum from '@square/dashboard-utilities/utils/enum';
import { constructUrl } from '@square/dashboard-utilities/utils/url';
import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
import RolodexError from '@square/dashboard-data/models/squareup/rolodex/error';
import Employee from '@square/dashboard-data/models/squareup/bills/employee';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export const MAX_FILE_NAME_LENGTH = 180;
export const SUPPORTED_MIME_TYPES = ['application/pdf', 'image/gif', 'image/jpg', 'image/jpeg', 'image/png'];
export const Type = new Enum(['IMAGE', 'PDF']);
export const State = new Enum(['ACTIVE', 'DELETED', 'PENDING']);

// returns the enum value for the AttachmentType
// https://prototype.sqprod.co/#/docs/squareup.rolodex.Attachment.FileType
export function getEnumValueFromAttachmentType(type) {
  switch (type) {
    case 1:
      return Type.IMAGE;
    case 2:
      return Type.PDF;
    default:
      return 'UNKNOWN_FILE_TYPE';
  }
}

// returns the enum value for the Attachment State
// https://prototype.sqprod.co/#/docs/squareup.rolodex.Attachment.State
export function getEnumValueFromAttachmentState(state) {
  switch (state) {
    case 1:
      return State.PENDING;
    case 2:
      return State.ACTIVE;
    case 3:
      return State.DELETED;
    default:
      return '';
  }
}
export const AttachmentResponse = ProtoBaseModel.extend({
  attachmentToken: attr(String),
  error: attr(RolodexError)
});
const Attachment = ProtoBaseModel.extend({
  attachmentToken: attr(String),
  contactToken: attr(String),
  contentType: attr(String),
  fileName: attr(String),
  fileType: attr(Type),
  fileSizeInBytes: attr(Number),
  state: attr(State),
  createdAt: attr(DateTime),
  employee: attr(Employee),
  upload: attr(File)
});
export function generateAttachmentLink(merchantToken, attachmentToken, preview) {
  assert('Merchant token required', merchantToken);
  assert('Attachment token required', attachmentToken);
  const params = {
    merchant_token: merchantToken,
    attachment_tokens: attachmentToken,
    preview
  };
  return constructUrl('/api/v1/rolodex/download-attachments', params);
}
export const CreateAttachmentsRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  attachments: repeated(Attachment)
});
export const CreateAttachmentsResponse = ProtoBaseModel.extend({
  numSucceededAttachments: attr(Number),
  numFailedAttachments: attr(Number),
  attachmentResponses: repeated(AttachmentResponse),
  attachments: repeated(Attachment)
});
export const DeleteAttachmentsRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  attachmentTokens: repeated(String)
});
export const DeleteAttachmentsResponse = ProtoBaseModel.extend({
  numSucceededAttachments: attr(Number),
  numFailedAttachments: attr(Number),
  attachmentResponses: repeated(AttachmentResponse)
});
export const GetAttachementsRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  attachmentTokens: repeated(String)
});
export const GetAttachementsResponse = ProtoBaseModel.extend({
  numSucceededAttachments: attr(Number),
  numFailedAttachments: attr(Number),
  attachmentResponses: repeated(AttachmentResponse),
  attachments: repeated(Attachment)
});
export const UpdateAttachmentRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  attachment: attr(Attachment)
});
export const UpdateAttachmentResponse = ProtoBaseModel.extend({
  attachmentResponse: attr(AttachmentResponse)
});
export default Attachment;